export default __webpack_public_path__ + "static/media/android-icon-disable.218e74a7.svg";